import { useCallback } from "react";
import {
    openTabState as challengesOpenState,
} from '../organize/Organize.state'
import { openTabState as designationOpenState } from '../designations/Designation.state';
import { openTabState as npcOpenState } from '../npc/Npc.state';
import { useResetRecoilState } from 'recoil';

const useResetOpenStates = () => {
  const resetOpenDesignationState = useResetRecoilState(designationOpenState)
  const resetOpenNpcState = useResetRecoilState(npcOpenState)
  const resetOpenChallengeState = useResetRecoilState(challengesOpenState)
  const doResetStates = useCallback(() => {
    resetOpenDesignationState()
    resetOpenNpcState()
    resetOpenChallengeState()
  }, [
    resetOpenDesignationState,
    resetOpenNpcState,
    resetOpenChallengeState,
  ])
  return doResetStates
};

export default useResetOpenStates